import React from 'react';
import { AlyzeLogoFull } from '@shared/components/icons';

export const FooterBottom: React.FC = () => {
  return (
    <div className="w-full flex justify-center items-center py-8">
      <div className="w-full h-auto">
        <AlyzeLogoFull color="#444444" className="w-full h-auto" />
      </div>
    </div>
  );
};
